import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { getUserData } from '@/auth/utils'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useTituloList(credorId) {
  // Use toast
  const toast = useToast()
  
  const userData = getUserData()

  const refTituloListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    // '#',
    { key: 'nome', label: "Devedor" },
    { key: 'numero_titulo' },
    { key: 'valor' },
    { key: 'vencimento' },
    { key: 'referencia' },
    { key: 'situacao' },
    { key: 'data_baixa', label: "Data Baixa" },
    { key: 'credor', label: "Credor" },
    { key: 'actions', label: "Ações" },
  ]
  const perPage = ref(15)
  const currentPage = ref(1)
  const perPageOptions = [10, 15, 25, 50, 100]
  const searchQuery = ref('')
  const statusFilter = ref('ativo')
  const dataBaixaInicialFilter = ref(null)
  const dataBaixaFinalFilter = ref(null)

  const dataMeta = ref({})

  const refetchData = () => {
    refTituloListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter, dataBaixaInicialFilter, dataBaixaFinalFilter], () => {
    refetchData()
  })

  const fetchTitulos = (ctx, callback) => {
    const params = {
      busca: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      credor: userData.credor.id,
      status: statusFilter.value
    }

    // Add date filters only for baixados/todos status
    if (statusFilter.value === 'baixado' || statusFilter.value === 'todos') {
      if (dataBaixaInicialFilter.value) {
        params.dataBaixaInicio = dataBaixaInicialFilter.value
      }
      if (dataBaixaFinalFilter.value) {
        params.dataBaixaFim = dataBaixaFinalFilter.value
      }
    }

    store
      .dispatch('app-titulo/fetchTitulos', params)
      .then(response => {
        const { data, meta } = response.data     
        callback(data)
        dataMeta.value = meta
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveTituloStatusVariant = status => {
    if (status === 'NEGATIVADO') return 'primary'
    if (status === 'BAIXADO') return 'success'
    if (status === 'PRESCRITO') return 'primary'
    if (status === 'CADASTRADO') return 'info'
    return 'primary'
  }

  const resolveTituloStatusText = text => {
    if (text === 'NEGATIVADO') return 'ABERTO'
    if (text === 'BAIXADO') return 'BAIXADO'
    if (text === 'PRESCRITO') return 'ABERTO'
    if (text === 'CADASTRADO') return 'ABERTO'
    return 'primary'
  }

  // Export functionality
  const exportTitulos = (format) => {
    const params = {
      format: format, // 'xlsx' or 'csv'
      busca: searchQuery.value,
      status: statusFilter.value
    }

    // Add date filters only for baixados/todos status
    if (statusFilter.value === 'baixado' || statusFilter.value === 'todos') {
      if (dataBaixaInicialFilter.value) {
        params.dataBaixaInicio = dataBaixaInicialFilter.value
      }
      if (dataBaixaFinalFilter.value) {
        params.dataBaixaFim = dataBaixaFinalFilter.value
      }
    }

    store
      .dispatch('app-titulo/exportTitulos', params)
      .then(response => {
        // Create download link
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-')
        const filename = `titulos-${statusFilter.value}-${timestamp}.${format}`
        
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        toast({
          component: ToastificationContent,
          props: {
            title: 'Exportação realizada',
            icon: 'DownloadIcon',
            variant: 'success',
            text: 'Arquivo baixado com sucesso!',
          },
        })
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro na exportação',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Não foi possível exportar os dados.',
          },
        })
      })
  }

  return {
    fetchTitulos,
    tableColumns,
    perPage,
    currentPage,
    dataMeta,
    perPageOptions,
    searchQuery,
    refTituloListTable,

    resolveTituloStatusVariant,
    resolveTituloStatusText,
    refetchData,
    exportTitulos,

    // Extra Filters
    statusFilter,
    dataBaixaInicialFilter,
    dataBaixaFinalFilter,
  }
}
